import React, { type PropsWithChildren } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { convertISODateFormat } from '@atlassian/jira-compatibility';
import { FormattedDate, useIntl } from '@atlassian/jira-intl';
import { AsyncProfileCardNext } from '@atlassian/jira-profilecard-next/src/async';
import { TenantContextSubscriber } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import messages from './messages';
import type { Props } from './types';

const DateAndUser = (props: Props) => {
	const {
		date,
		user: { accountId, displayName },
	} = props;

	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<FormattedDate
				value={convertISODateFormat(date)}
				year="numeric"
				month="short"
				day="2-digit"
			/>
			<Separator>{formatMessage(messages.byKeyword)}</Separator>
			<DisplayNameWrapper>
				<AsyncProfileCardNext
					accountId={accountId}
					TenantContextSubscriber={TenantContextSubscriber}
				>
					<Button appearance="link" spacing="none">
						{displayName}
					</Button>
				</AsyncProfileCardNext>
			</DisplayNameWrapper>
		</Wrapper>
	);
};

export default DateAndUser;

const Wrapper = ({ children }: PropsWithChildren<{}>) => <Box xcss={WrapperStyles}>{children}</Box>;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Separator = styled.span({
	margin: `0 ${token('space.050')}`,
});

const WrapperStyles = xcss({
	display: 'flex',
	whiteSpace: 'nowrap',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DisplayNameWrapper = styled.div({
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
	overflow: 'hidden',
});
